/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Admin_Field_Tax_Country_HintInputs */



/**
* | output |
* | --- |
* | "Two-letter country code, e.g. DE. Decides the VAT treatment of this partner's invoices and credit notes." |
*
* @param {Partner_Admin_Field_Tax_Country_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_field_tax_country_hint = /** @type {((inputs?: Partner_Admin_Field_Tax_Country_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Field_Tax_Country_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zweistelliger Ländercode, z. B. DE. Bestimmt die Umsatzsteuerbehandlung der Rechnungen und Gutschriften dieses Partners.")
	return /** @type {LocalizedString} */ ("Two-letter country code, e.g. DE. Decides the VAT treatment of this partner's invoices and credit notes.")
});